<!-- Header -->
<app-top-bar [title]="pageTitle()" [customBack]="goToPayments"></app-top-bar>
@if (isLoading()) {
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
}
@if (lockedByOther()) {
    <div class="sync-banner">
        {{ 'PAY_AT_TABLE.SOMEONE_ELSE_PAYING' | translate }}
    </div>
}
<div class="page">
    <!-- ====== EVENLY LAYOUT ====== -->
    @if (splitType() === 'evenly') {
        <app-split-evenly
            [totalPeople]="totalPeople()"
            [payingFor]="payingFor()"
            [maxPayers]="maxPayers()"
            [currentPayers]="currentPayers()"
            [billAmount]="billAmount()"
            [totalRemaining]="totalRemaining()"
            (incTotalPeople)="incTotalPeople()"
            (decTotalPeople)="decTotalPeople()"
            (incPayingFor)="incPayingFor()"
            (decPayingFor)="decPayingFor()">
        </app-split-evenly>
    }

    <!-- ====== CUSTOM LAYOUT ====== -->
    @if (splitType() === 'custom') {
        <app-split-custom-amount
            [customAmount]="customAmount()"
            [billAmount]="billAmount()"
            [totalRemaining]="totalRemaining()"
            (amountChange)="customAmount.set($event)"
            (submit)="calculate()">
        </app-split-custom-amount>
    }

    <!-- ====== ITEMS LAYOUT ====== -->
    @if (splitType() === 'items') {
        <app-split-items
            [items]="items()"
            [selectedQty]="selectedQty()"
            [billAmount]="billAmount()"
            [totalRemaining]="totalRemaining()"
            (incItem)="incItem($event)"
            (decItem)="decItem($event)">
        </app-split-items>
    }

    @if (splitType() === 'evenly' || splitType() === 'items') {
        <button class="btn selection-btn" type="button" [disabled]="!hasPendingSelection() || isLoading() || lockedByOther()"
            (click)="confirmSelection()">
            {{ 'PAY_AT_TABLE.CONFIRM_SELECTION' | translate }}
        </button>
    }

    <app-tipping-form [total]="this.subtotal()" (tipApplied)="onTipApplied($event)" />

    <div class="order-summary">
        <div>
            <span>{{ 'ORDER.SUBTOTAL' | translate }}</span>
            <span>{{ displaySubtotal() | currencySpace }}</span>
        </div>

        @if (appliedPromo(); as promo) {
        @if (promo.amount) {
        <div>
            <span>{{ 'PAY_AT_TABLE.PROMO' | translate }}</span>
            <span class="sum-val blue">- {{ promo.amount | currencySpace }}</span>
        </div>
        }
        }

        @if (discount()) {
        <div>
            <span>{{ 'PAY_AT_TABLE.DISCOUNT' | translate }}</span>
            <span class="sum-val blue">- {{ discount() | currencySpace }}</span>
        </div>
        }

        @if (remainingBalance() > 0) {
        <div>
            <span>{{ 'VOUCHER.REMAINING_BALANCE' | translate }}</span>
            <span>{{ remainingBalance() | currencySpace }}</span>
        </div>
        }

        @if (fees().length) {
        @for (fee of fees(); track $index) {
        @if (fee.amount) {
        <div>
            <span>{{ fee.name }}</span>
            <span class="sum-val blue">{{ fee.amount | currencySpace }}</span>
        </div>
        }
        }
        } @else if (serviceFee()) {
        <div>
            <span>{{ 'COMMON.FEES' | translate }}</span>
            <span class="sum-val blue">{{ serviceFee() | currencySpace }}</span>
        </div>
        }

        <div *ngIf="tipAmount()">
            <span>
                {{ 'TIP.TIP' | translate }}
            </span>
            <span class="sum-val blue">
                {{ tipAmount() | currencySpace }}
            </span>
        </div>

        <div class="sum-row total">
            <span class="sum-label">{{ 'ORDER.TOTAL' | translate }}</span>
            <span>{{ totalWithTip() | currencySpace }}</span>
        </div>
    </div>

    <div class="actions">
        @if (!isOrderFree()) {
            <app-payment-options-sheet
                [paymentMethods]="paymentMethods"
                [disabled]="isLoading() || hasPendingSelection() || lockedByOther()"
                (optionSelected)="onPaymentOptionSelected($event)">
            </app-payment-options-sheet>
        }
    </div>
</div>

<app-loader-overlay [active]="isLoading()" />
